import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ConfigParamService } from './config-param/config-param.service';
import { UserInfoService } from './auth/user-info/user-info.service';
import { getFullUrl } from '../shared/utils/url';
import { map, Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie';
import { environment } from 'src/environments/environment';

export const RedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const routePath = route.url[0].path;
  if (routePath === 'grafana') {
    return redirectGrafana(route);
  } else if (routePath === 'login') {
    return redirectLogin();
  } else if (routePath === 'logout') {
    return redirectLogout(route);
  } else if (routePath === 'change-password') {
    return redirectChangePassword(route);
  } else return false;
};

const redirectGrafana = (route: ActivatedRouteSnapshot): boolean => {
  const router = inject(Router);
  const configParamService = inject(ConfigParamService);

  const grafanaPathConfigParam =
    configParamService.getConfigParamByParamName('grafanaPath');
  if (grafanaPathConfigParam === undefined) {
    console.error('grafana path undefined');
    return false;
  }
  const grafanaUrl = grafanaPathConfigParam.paramValueString ?? '';

  const { path } = route.data;
  if (path === 'grafanaPath' && grafanaUrl) {
    window.location.replace(grafanaUrl);
    return true;
  } else {
    router
      .navigate(['/protected/dashboard'], { replaceUrl: true })
      .catch(console.error);
    return false;
  }
};

const redirectLogin = (): Observable<boolean> => {
  const userInfoService = inject(UserInfoService);
  const router = inject(Router);

  return userInfoService.refreshUserInfo().pipe(
    map((userInfo) => {
      if (userInfo === undefined) {
        return true;
      }
      router
        .navigate(['/protected/dashboard'], { replaceUrl: true })
        .catch(console.error);
      return false;
    })
  );
};

const redirectLogout = (route: ActivatedRouteSnapshot): Observable<boolean> => {
  const userInfoService = inject(UserInfoService);
  const router = inject(Router);
  const cookieService = inject(CookieService);

  const { path, redirect } = route.data;
  return userInfoService.refreshUserInfo().pipe(
    map((userInfo) => {
      if (userInfo !== undefined) {
        const token = cookieService.get('session_id');
        cookieService.remove('session_id');
        window.location.replace(
          getFullUrl(
            environment.guiBackendRootEndpoint,
            `${path}?after-redirect=${redirect}&X-Auth-Token=${token}`
          )
        );
        return true;
      }
      router.navigate(['/login'], { replaceUrl: true }).catch(console.error);
      return false;
    })
  );
};

const redirectChangePassword = (
  route: ActivatedRouteSnapshot
): Observable<boolean> => {
  const userInfoService = inject(UserInfoService);
  const router = inject(Router);
  const cookieService = inject(CookieService);

  const { acr, redirect } = route.data;
  const lang = (cookieService.get('lang') ?? 'en')
    .substring(0, 2)
    .toLocaleLowerCase();
  return userInfoService.refreshUserInfo().pipe(
    map((userInfo) => {
      if (userInfo !== undefined) {
        const token = cookieService.get('session_id');
        cookieService.remove('session_id');
        window.location.replace(
          getFullUrl(
            environment.guiBackendRootEndpoint,
            `oauth2/login/alt/${acr}?after-redirect=${redirect}&ui_locales=${lang}&X-Auth-Token=${token}`
          )
        );
        return true;
      }
      router.navigate(['/login'], { replaceUrl: true }).catch(console.error);
      return false;
    })
  );
};
